import {
  CLINICAL_DASHBOARD_EXTERNAL_HREFS,
  clinicalDashboardHref,
  findClinicalDashboardItem,
} from "@/lib/prism-clinical-dashboard"

export const PRISM_DASHBOARD_NAV_MESSAGE = "prism-dashboard-nav" as const

export type PrismDashboardNavMessage = {
  type: typeof PRISM_DASHBOARD_NAV_MESSAGE
  linkId: string
}

/** STEPS dashboard link id → Clinical Education hub segment. */
const STEPS_LINK_TO_ITEM_ID: Record<string, string> = {
  "dashboard-navigationitem-navigate-link-program.information": "program-details",
  "dashboard-navigationitem-navigate-link-admin.profile": "students",
  "dashboard-navigationitem-navigate-link-faculty.information": "faculty-staff",
  "dashboard-navigationitem-navigate-link-admin.compliance": "student-compliance",
  "dashboard-navigationitem-navigate-link-admin.caas": "faculty-compliance",
  "dashboard-navigationitem-navigate-link-exxat.reports": "reports",
  "dashboard-navigationitem-navigate-link-admin.course": "courses",
  "dashboard-navigationitem-navigate-link-curriculum.management": "curriculum-mapping",
  "dashboard-navigationitem-navigate-link-competency.management": "competency-management",
  "dashboard-navigationitem-navigate-link-admin.site": "sites",
  "dashboard-navigationitem-navigate-link-admin.placement-requests": "process-my-requests",
  "dashboard-navigationitem-navigate-link-admin.steps": "placements",
  "dashboard-navigationitem-navigate-link-admin.steps-activities": "learning-activities",
}

export function resolveStepsDashboardNavHref(
  linkId: string,
  productRoot = "prism",
): string | null {
  const itemId = STEPS_LINK_TO_ITEM_ID[linkId]
  if (!itemId) return null

  const external = CLINICAL_DASHBOARD_EXTERNAL_HREFS[itemId]
  if (external) return external

  const item = findClinicalDashboardItem(itemId)
  if (!item) return `/${productRoot}/${itemId}`
  return clinicalDashboardHref(item, productRoot)
}

export function isPrismDashboardNavMessage(
  data: unknown,
): data is PrismDashboardNavMessage {
  return (
    typeof data === "object" &&
    data !== null &&
    (data as PrismDashboardNavMessage).type === PRISM_DASHBOARD_NAV_MESSAGE &&
    typeof (data as PrismDashboardNavMessage).linkId === "string"
  )
}
